import StatsPanel from '../StatsPanel'
import { ReactComponent as WaveIcon } from '../wave.svg'
import styles from './TriggerCard.module.scss'

function TriggerCard({ title, stats }) {
  return (
    <div className={styles.card}>
      <div className={styles.cardContent}>
        <div className={styles.iconWrapper}>
          <WaveIcon />
        </div>
        <div className={styles.title}>{title}</div>
      </div>
      <StatsPanel stats={stats} variant="trigger" />
    </div>
  )
}

export default TriggerCard
